import functions from './functions.js';

class Calendar {

    availabilityMask = null;
    periods = null;
    translations = null;
    containerClass = null;
    today = null;
    yesterday = null;
    config = {};
    defaults = {
        availabilityMask: '',
        periods: [],
        translations: {},
        containerClass: '',
        dateFormat: "Y-m-d",
        showMonths: 3,
        nextArrow: '<i class="las la-angle-right la-lg"></i>',
        prevArrow: '<i class="las la-angle-left la-lg"></i>',

        checkOutClass: 'checkOutAllowed',
        checkInClass: 'checkInAllowed',
        notAvailableClass: 'notAvailable',
        notArrivalDepartureClass: 'disabled',
        notMinStayClass: 'disabled',

        rangeSeparator: ' - ',

        defaultDate: [],
        minDate: 'today',
        inline: true,
        altInput: true,
        wrap: false,
        altFormat: "j.m.Y",
    };

    constructor($elem, config, callback) {

        //console.log($elem);
        this.config = $.extend({}, this.defaults, config);

        this.today = new Date();
        this.today.setHours(0,0,0,0);

        this.yesterday = new Date(this.today.getTime());
        this.yesterday.setDate(this.yesterday.getDate() - 1);

        if(functions.mobileAndTabletCheck()) {
            this.config.showMonths = 1;
        }


        this.flatpickr = $elem.flatpickr({

                altInput: this.config.altInput,
                wrap: this.config.wrap,
                altFormat: this.config.altFormat,
                dateFormat: this.config.dateFormat,
                disableMobile: true,
                mode: this.config.mode,
                minRange: 0,
                showMonths: this.config.showMonths,
                inline: this.config.inline,
                defaultDate: this.config.defaultDate,
                minDate: this.config.minDate,
                maxDate: this.config.maxDate,
                disable: [
                    date => {
                        return ! this.isAvailable(date);
                    }
                ],
                onDayCreate: (dObj, dStr, fp, dayElem) => {

                    let dateBefore = new Date(dayElem.dateObj.getTime());
                    dateBefore.setDate(dateBefore.getDate() - 1);

                    let dateIsAvailable = this.isAvailable(dayElem.dateObj);
                    let dateBeforeIsAvailable = this.isAvailable(dateBefore);

                    if (dateBeforeIsAvailable && ! dateIsAvailable) {
                        dayElem.className += ' ' + this.config.checkOutClass;
                        $(dayElem).removeClass('flatpickr-disabled');
                    } else if ( ! dateBeforeIsAvailable && dateIsAvailable) {
                        dayElem.className += ' ' + this.config.checkInClass;
                    } else if ( ! dateIsAvailable) {
                        dayElem.className += ' ' + this.config.notAvailableClass;

                        $(dayElem).tooltip({
                            title: this.config.translations.not_available || ''
                        });
                    }

                    if ( ! this.hasPrice(this.config.periods, dayElem.dateObj)) {
                        dayElem.className += ' ' + this.config.notAvailableClass;

                        $(dayElem).tooltip({
                            title: this.config.translations.not_available || ''
                        });

                    } else {
                        if ( ! this.isArrivalPossible(this.config.periods, dayElem.dateObj) && ! this.isDeparturePossible(this.config.periods, dayElem.dateObj)) {

                            dayElem.className += ' flatpickr-disabled ' + this.config.notArrivalDepartureClass;

                            if (fp.selectedDates[0]) {
                                $(dayElem).tooltip({
                                    title: this.config.translations.not_departure_day || ''
                                });
                            } else {
                                $(dayElem).tooltip({
                                    title: this.config.translations.not_arrival_day || ''
                                });
                            }
                        }

                        if (fp.selectedDates[0] && ! fp.selectedDates[1]) {
                            let minStay = this.getMinStay(this.config.periods, fp.selectedDates[0]);
                            let maxStay = this.getMaxStay(this.config.periods, fp.selectedDates[0]);
                            let isDeparturePossible = this.isDeparturePossible(this.config.periods, dayElem.dateObj);

                            // get difference between selected and current date of the loop
                            let diff = this.dateDiff(dayElem.dateObj, fp.selectedDates[0]);

                            /*if(minStay == maxStay) {

                                let dateTo = new Date(fp.selectedDates[0]);
                                dateTo.setDate(dateTo.getDate() + maxStay);
                                $elem[0]._flatpickr.setDate([dateFrom, dateTo]);

                            } */

                            if (minStay) {
                                // check if min stay is met - skip selected date
                                if (Math.abs(diff) < minStay) {
                                    dayElem.className += ' flatpickr-disabled ' + this.config.notMinStayClass;
                                    if (diff) {
                                        $(dayElem).tooltip({
                                            title: this.config.translations.min_stay_is && this.config.translations.min_stay_is.replace('{$min_stay}', minStay) || ''
                                        });
                                    }
                                } else {
                                    $(dayElem).removeClass('flatpickr-disabled');
                                }

                                if(isDeparturePossible && Math.abs(diff) > minStay) {
                                    $(dayElem).removeClass('flatpickr-disabled');
                                }
                            }
                        }
                    }

                },
                onChange: (selectedDates, dateStr, instance) => {
                    callback(this, selectedDates, dateStr, instance);
                },
                onReady: (selectedDates, dateStr, instance) => {

                    if (this.config.containerClass) {
                        let classList = instance.calendarContainer.classList;
                        let classes = this.config.containerClass.split(' ');
                        classes.forEach((css_class, index) => {
                            classList.add(css_class);
                        });
                    }
                },

                nextArrow: this.config.nextArrow,
                prevArrow: this.config.prevArrow,
                locale: {
                    rangeSeparator: this.config.rangeSeparator
                }
        });
    }

    isAvailable(date) {
        if (date < this.yesterday) {
            return 0;
        }

        if ( ! this.config.availabilityMask) return false;

        let diff = this.dateDiff(date, this.today);
        return +this.config.availabilityMask.substring(diff, diff + 1);
        //return 1;
    }

    formatDate(date) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        let d = new Date(date);
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('.')
    }

    dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());

        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    }

    isArrivalPossible(periods, date) {

        if ( ! periods.length) return false;

        let arrivalIsPossible = false;
        let dayOfWeek = date.getDay();
        dayOfWeek = (dayOfWeek == 0 ? 7 : dayOfWeek).toString();

        let period = this.filterPeriod(periods, date);


        if (period) {
            if ( ! period.days) {
                arrivalIsPossible = true;
            } else {
                let arrivalDays = period.days.split(',');

                if($.inArray(dayOfWeek, arrivalDays) !== -1) {
                    arrivalIsPossible = true;
                }
            }
        }

        return arrivalIsPossible;
    }

    isDeparturePossible(periods, date) {

        if ( ! periods.length) return false;

        let departureIsPossible = false;
        let dayOfWeek = date.getDay();
        dayOfWeek = (dayOfWeek == 0 ? 7 : dayOfWeek).toString();

        let period = this.filterPeriod(periods, date);

        if (period) {
            if ( ! period.departureDays) {
                departureIsPossible = true;
            } else {
                let departureDays = period.departureDays.split(',');

                if($.inArray(dayOfWeek, departureDays) !== -1) {
                    departureIsPossible = true;
                }
            }
        }

        return departureIsPossible;
    }

    filterPeriod(periods, date) {
        return $.grep(periods, period => {
            if (date >= this.cleanDate(period.dateFrom) && date <= this.cleanDate(period.dateTo)) {
                return period;
            }
        })[0];
    }

    hasPrice(periods, date) {

        if ( ! periods.length) return false;

        return this.filterPeriod(periods, date) ? true : false;
    }

    getMinStay(periods, date) {

        if ( ! periods.length) return 0;

        let period = this.filterPeriod(periods, date);
        return period && period.minDays ? period.minDays : 0;
    }

    getMaxStay(periods, date) {

        if ( ! periods.length) return 0;

        let period = this.filterPeriod(periods, date);
        return period && period.maxDays ? period.maxDays : 0;
    }

    cleanDate(date) {
        date = new Date(date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
}

export {
    Calendar
}